import React, { SVGProps } from 'react';

const Organization: React.FC<SVGProps<SVGSVGElement>> = props => (
  <svg width="20px" height="20px" viewBox="0 0 20 20" {...props}>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h20v20H0z" />
      <path
        d="M12 3.375c.345 0 .625.28.625.625v4c0 .345-.28.625-.625.625h-1.375v1.25H15.5c.314 0 .574.231.618.533l.007.092v2.469a2.126 2.126 0 11-1.25 0v-1.844h-4.25v1.844c.823.252 1.432.99 1.495 1.88l.005.151a2.125 2.125 0 11-2.75-2.032v-1.843h-4.25v1.844a2.126 2.126 0 11-1.25 0V10.5c0-.345.28-.625.625-.625h4.875v-1.25H8A.625.625 0 017.375 8V4c0-.345.28-.625.625-.625h4zm-2 10.75a.875.875 0 100 1.75.875.875 0 000-1.75zm5.5 0a.875.875 0 100 1.75.875.875 0 000-1.75zm-11 0a.875.875 0 100 1.75.875.875 0 000-1.75zm6.875-9.5h-2.75v2.75h2.75v-2.75z"
        fill="#333"
      />
    </g>
  </svg>
);

export default Organization;
